import Autocomplete from './variants/Autocomplete';
export * from './externals';
export * from './types';
export { Autocomplete };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/autocomplete/dist/esm/index.js
// module id = 1717
// module chunks = 11